import * as tslib_1 from "tslib";
import { throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from '../base.service';
import { OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
var MonoovaReconSettlementResultService = /** @class */ (function (_super) {
    tslib_1.__extends(MonoovaReconSettlementResultService, _super);
    function MonoovaReconSettlementResultService(http) {
        var _this = _super.call(this, 'monoova-recon-settlement-result', http) || this;
        _this.http = http;
        return _this;
    }
    MonoovaReconSettlementResultService.prototype.ngOnInit = function () {
    };
    MonoovaReconSettlementResultService.prototype.getAllBankReResultByPaging = function (searchCondition, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        var embeddedStr = '&embedded=transaction,statement-item&f_statementItem.sub_transaction_type=GatewayNppReceivePayment&f_errorCode=0';
        return this.http.get(this.url + "?" + paging.getPagingStr() + (embeddedStr + searchCondition)).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    MonoovaReconSettlementResultService.prototype.getAllBankReIssueResultByPaging = function (searchCondition, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        var embeddedStr = '&embedded=transaction,statement-item&f_errorCode=B117&f_errorCode=B217&f_errorCode=B817';
        return this.http.get(this.url + "?" + paging.getPagingStr() + (embeddedStr + searchCondition)).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    MonoovaReconSettlementResultService.prototype.getAllBankRfResultByPaging = function (searchCondition, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        var embeddedStr = '&embedded=transaction,statement-item&f_statementItem.sub_transaction_type=GatewayNppReceivableRefund&f_errorCode=0';
        return this.http.get(this.url + "?" + paging.getPagingStr() + (embeddedStr + searchCondition)).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    MonoovaReconSettlementResultService.prototype.getAllBankRfIssueResultByPaging = function (searchCondition, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        var embeddedStr = '&embedded=transaction,statement-item&f_errorCode=B617&f_errorCode=B717&f_errorCode=B917';
        return this.http.get(this.url + "?" + paging.getPagingStr() + (embeddedStr + searchCondition)).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    MonoovaReconSettlementResultService.prototype.getAllBankAbResultByPaging = function (searchCondition, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        var embeddedStr = '&embedded=transaction,statement-item&f_statementItem.sub_transaction_type=GatewayNppDirectCredit&f_errorCode=0';
        return this.http.get(this.url + "?" + paging.getPagingStr() + (embeddedStr + searchCondition)).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    MonoovaReconSettlementResultService.prototype.getAllBankAbIssueResultByPaging = function (searchCondition, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        var embeddedStr = '&embedded=transaction,statement-item&f_errorCode=B317&f_errorCode=B417&f_errorCode=B517&f_errorCode=B1017';
        return this.http.get(this.url + "?" + paging.getPagingStr() + (embeddedStr + searchCondition)).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    MonoovaReconSettlementResultService.prototype.getAllCouponByBusinessIdByPaging = function (searchCondition, businessId, sortOprions, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        var idStr = '&f_businessId_op==&f_businessId=' + businessId;
        var sortStr = sortOprions.getSortString();
        // this.embeddedStr = '&embedded=coupons-promo';
        return this.http.get(this.url + "/get-coupons" + sortStr + paging.getPagingStr() + (this.embeddedStr + idStr + searchCondition) + "&sort=id,desc").pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    MonoovaReconSettlementResultService.prototype.getAllByBusinessIdByPaging = function (searchCondition, businessId, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        return this.http.get(this.url + "?" + paging.getPagingStr() + (this.embeddedStr + searchCondition) + "&sort=id,desc" + (businessId ? "&f_businessId=" + businessId + "&f_businessId_op==" : '')).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    MonoovaReconSettlementResultService.prototype.getAllByWalletIdsByPaging = function (walletIds, searchCondition, paging) {
        var sortStr = '&sort=id,asc';
        var walletIdsStr = '';
        if (walletIds) {
            walletIds.forEach(function (id) {
                walletIdsStr += "&f_acceptedMerchants=" + id;
            });
        }
        if (walletIdsStr) {
            walletIdsStr += '&f_acceptedMerchants_op=IN';
        }
        return this.http.get(this.url + "?" + paging.getPagingStr() + walletIdsStr + sortStr + searchCondition).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    MonoovaReconSettlementResultService.prototype.publishCouponById = function (id) {
        return this.http.post(this.url + "/" + id + "/dispatch", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    MonoovaReconSettlementResultService.prototype.getNavigationTask = function () {
        return this.http.post(this.url + "/get-navigation-task", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    MonoovaReconSettlementResultService.prototype.getOverviewTask = function () {
        return this.http.post(this.url + "/get-overview-task", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    MonoovaReconSettlementResultService.prototype.addExtra = function (id) {
        return this.http.post(this.url + "/" + id + "/create-extra", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    MonoovaReconSettlementResultService.prototype.applyCoupon = function (id) {
        return this.http.post(this.url + "/" + id + "/apply", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    MonoovaReconSettlementResultService.prototype.copyCoupon = function (id) {
        return this.http.post(this.url + "/" + id + "/copy", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    MonoovaReconSettlementResultService.prototype.closeCoupon = function (id) {
        return this.http.post(this.url + "/" + id + "/close", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    MonoovaReconSettlementResultService.prototype.updateNote = function (id, data) {
        return this.http.put(this.url + "/update-notes/" + id, data).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    MonoovaReconSettlementResultService.prototype.getAllLatipayByPaging = function (searchCondition, paging) {
        var idSortStr = '&sort=id,desc';
        if (!searchCondition) {
            searchCondition = '';
        }
        var str = '&f_type_op==&f_type=1';
        return this.http.get(this.url + "?" + paging.getPagingStr() + (this.embeddedStr + searchCondition + idSortStr)).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    MonoovaReconSettlementResultService.prototype.getAllLatipayByMerchantIdByPaging = function (merchantId, searchCondition, paging) {
        var idSortStr = '&sort=id,desc';
        if (!searchCondition) {
            searchCondition = '';
        }
        var str = '&f_merchantId_op==&f_merchantId=' + merchantId;
        return this.http.get(this.url + "?" + paging.getPagingStr() + (this.embeddedStr + searchCondition + idSortStr + str)).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    MonoovaReconSettlementResultService.prototype.get = function (id) {
        var embeddedStr = '&embedded=transaction,statement-item';
        var str = embeddedStr ? id + "?" + embeddedStr : id;
        return this.http.get(this.url + "/" + str).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    MonoovaReconSettlementResultService.prototype.updateStatus = function (id, value) {
        return this.http.put(this.url + "/update-status/" + id, value).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    return MonoovaReconSettlementResultService;
}(BaseService));
export { MonoovaReconSettlementResultService };
